import React from 'react';

function Subscription({ item, className }) {
    const { form = {}, fields = {}, settings = {} } = item;

    const getName = (name) => {
        const serviceKeys = {
            mailchimp: {
                email: 'EMAIL',
                firstName: 'FNAME',
                lastName: 'LNAME',
            },
            convertkit: {
                email: 'email_address',
                firstName: 'fields[first_name]',
                lastName: 'fields[last_name]',
            },
        };
        return (
            serviceKeys[settings.service] && serviceKeys[settings.service][name]
        );
    };

    const formFields = Object.entries(fields).map(([name, field], i) =>
        false === field._enabled ? null : (
            <div className="form-group" key={i}>
                {field.label && (
                    <label className="form-label">{field.label}</label>
                )}
                <input
                    name={getName(name)}
                    className="form-control"
                    {...field.attr}
                />
            </div>
        )
    );

    return (
        <form id={item.id} className={className}>
            <div className="fields-wrapper">
                {formFields}
                <button type="button">{form?.button?.content}</button>
            </div>
        </form>
    );
}

export default Subscription;
